import { useQuery } from "@tanstack/react-query";

import { useAuthStore } from "@krea/shared/features/auth/authStore";

import { queryKeyMap } from "@/features/query-client";

import { getMe } from "../api";

export const useGetMeQuery = () => {
  const accessToken = useAuthStore((state) => state.accessToken);

  return useQuery({
    queryKey: queryKeyMap.getMe,
    staleTime: 1000 * 60,
    queryFn: async () => {
      return await getMe();
    },
    enabled: !!accessToken,
  });
};
